/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import { Platform, StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const cashStyles = StyleSheet.create({
  workspaceRoot: {
    flex: 1,
    alignSelf: 'stretch',
    width: '100%',
    backgroundColor: ticketColors.bg,
    minHeight: 0,
    ...(Platform.OS === 'web'
      ? ({ minHeight: '100%' as unknown as number, height: '100%' as unknown as number } as const)
      : null),
  },
  modeChrome: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: 0,
    gap: spacing.sm,
    backgroundColor: ticketColors.bg,
  },
  readOnlyPill: {
    alignSelf: 'flex-start',
    paddingHorizontal: spacing.sm,
    paddingVertical: 6,
    borderRadius: 999,
    backgroundColor: ticketColors.paper,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },
  readOnlyPillText: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 17,
  },
  recordHeaderShell: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
    paddingBottom: 0,
    gap: spacing.sm,
    alignSelf: 'stretch',
    backgroundColor: ticketColors.bg,
  },
  deskToolbarRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
  },
  deskActionRailWrap: {
    flexWrap: 'wrap',
    flexShrink: 1,
    justifyContent: 'flex-end',
    maxWidth: '100%',
  },
  deskActionBtn: {
    minHeight: 40,
    height: 'auto',
    paddingVertical: 10,
  },
  // ── Square tools tiles (h42 / r10 / tile) ──
  deskActionTile: {
    height: 42,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.tile,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
  },
  deskActionTileText: {
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  deskActionTileGold: {
    height: 42,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 14,
  },
  deskActionTileGoldText: {
    fontSize: 13,
    fontWeight: '800',
    color: ticketColors.goldInk,
    fontFamily: ticketFonts.sans,
  },
  deskIdentity: {
    flex: 1,
    minWidth: 220,
    gap: 4,
  },
  deskTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 10,
  },
  deskTitle: {
    fontSize: 18,
    fontWeight: '700',
    letterSpacing: -0.3,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  deskStatus: {
    fontSize: 12,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },
  deskStatusOpen: {
    color: ticketColors.ok,
  },
  deskStatusClosed: {
    color: ticketColors.gold,
  },
  deskSubtitle: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
  },
  recordMetricsRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: spacing.sm,
    alignSelf: 'stretch',
  },
  recordIdentityCard: {
    alignSelf: 'stretch',
    borderRadius: 0,
    borderWidth: 0,
    backgroundColor: 'transparent',
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  recordIdentityCardTop: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
  },
  recordMetricCard: {
    flex: 1,
    flexBasis: 140,
    minWidth: 128,
  },
  recordMetricCardEmphasis: {
    flex: 1,
    flexBasis: 140,
    minWidth: 128,
    borderColor: ticketColors.gold,
  },
  recordHeaderIdentity: {
    flex: 1,
    minWidth: 220,
    gap: spacing.xs,
  },
  recordHeaderTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  recordHeaderTitle: {
    ...typography.titleXL,
    color: ticketColors.ink,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  recordHeaderSubtitle: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
  },
  recordHeaderActions: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
    alignItems: 'center',
  },
  recordHeaderSecondaryBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    height: 40,
    paddingHorizontal: 14,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: 'transparent',
  },
  recordHeaderPrimaryBtn: {
    height: 40,
    paddingHorizontal: 14,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
  },
  workspaceSectionToggleWrap: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
    backgroundColor: ticketColors.bg,
  },
  workspaceTabBar: {
    flexDirection: 'row',
    alignItems: 'stretch',
    gap: 4,
    padding: 4,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  workspaceTabItem: {
    flex: 1,
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.sm,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 40,
  },
  workspaceTabItemSelected: {
    backgroundColor: ticketColors.gold,
  },
  workspaceTabText: {
    ...typography.body,
    fontSize: 14,
    lineHeight: 20,
    color: ticketColors.ink2,
    fontWeight: '600',
    textAlign: 'center',
  },
  workspaceTabTextSelected: {
    color: ticketColors.goldInk,
    fontWeight: '700',
  },
  workspaceTabLabelRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
  workspaceTabAttentionDot: {
    width: 7,
    height: 7,
    borderRadius: 999,
    backgroundColor: ticketColors.gold,
  },
  workspaceTabAttentionDotOnSelected: {
    backgroundColor: ticketColors.goldInk,
  },
  workspaceTabPane: {
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.md,
    paddingBottom: spacing.md,
    gap: spacing.sm,
    alignSelf: 'stretch',
  },
  workspaceTabCard: {
    ...ticketSurfaces.paperSheet,
    ...ticketSurfaces.paperSheetPadded,
  },
  workspaceTabCardFlush: {
    ...ticketSurfaces.paperSheet,
  },
  historialFilterToolbar: {
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
  },
  historialFilterToolbarRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing.md,
    rowGap: spacing.sm,
  },
  historialFilterToolbarChips: {
    flexShrink: 1,
    flexGrow: 0,
    maxWidth: '100%',
  },
  historialFilterToolbarPickers: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: spacing.sm,
  },
  historialFilterToolbarPicker: {
    flexGrow: 0,
    flexShrink: 1,
    minWidth: 148,
    maxWidth: 240,
  },
  historialFilterToolbarLink: {
    ...typography.caption,
    color: ticketColors.gold,
    fontWeight: '700',
    paddingVertical: spacing.sm,
  },
  historialSingleColumn: {
    flex: 1,
    minHeight: 0,
    alignSelf: 'stretch',
    width: '100%',
  },
  historialTableCard: {
    ...ticketSurfaces.paperSheet,
    flex: 1,
    minHeight: 0,
  },
  historialTableHeaderBand: {
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.paper2,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
  },
  historialTableFooter: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    backgroundColor: ticketColors.paper2,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.md,
  },
  historialListFullWidth: {
    flex: 1,
    minHeight: 0,
  },
  historialDetailFullWidth: {
    flex: 1,
    minHeight: 0,
    gap: spacing.sm,
    paddingTop: spacing.sm,
    paddingBottom: spacing.lg,
  },
  workspaceContentPane: {
    flex: 1,
    minHeight: 0,
    alignSelf: 'stretch',
  },
  workspaceTabScroll: {
    flex: 1,
    minHeight: 0,
  },
  workspaceTabScrollContent: {
    flexGrow: 1,
    paddingBottom: spacing.xxl,
    alignSelf: 'stretch',
    width: '100%',
  },
  workspaceTabScopeCaption: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  recordPagePanel: {
    alignSelf: 'stretch',
    width: '100%',
  },
  recordPageSideSectionTitle: {
    ...typography.caption,
    color: ticketColors.ink2,
    fontWeight: '800',
    letterSpacing: 0.35,
    textTransform: 'uppercase',
  },
  readOnlyStripHint: {
    ...typography.caption,
    color: ticketColors.ink2,
    flexBasis: '100%',
  },
  auditModalCard: {
    maxWidth: 720,
    maxHeight: '92%' as unknown as number,
    gap: spacing.md,
  },
  historyTableFlatRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.md,
    paddingHorizontal: spacing.md,
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: ticketColors.rule,
    minHeight: 48,
  },
  historyTableFlatRowSelected: {
    backgroundColor: ticketColors.paper2,
  },
  turnoModeScroll: {
    flex: 1,
    minHeight: 0,
  },
  turnoModeContent: {
    paddingBottom: spacing.xxl,
    gap: spacing.sm,
    alignSelf: 'stretch',
    width: '100%',
  },
  turnoMobileBody: {
    gap: spacing.md,
    paddingHorizontal: spacing.md,
    alignSelf: 'stretch',
  },
  linkRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
    paddingVertical: spacing.sm,
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
  },
  linkTitle: {
    ...typography.body,
    fontSize: 15,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  linkSubtitle: {
    ...typography.caption,
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink3,
  },
  linkTextCol: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  branchActivityLink: {
    ...ticketSurfaces.paperSheet,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 12,
    paddingHorizontal: 14,
    marginTop: spacing.sm,
  },
  // ── Mobile clean design ──
  recordMobileStatusRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  recordMobileTitle: {
    fontSize: 17,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  recordMobileSubtitle: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 17,
  },
  statusPillMobile: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 999,
    flexShrink: 0,
  },
  statusPillMobileSuccess: {
    backgroundColor: 'rgba(34,197,94,0.14)',
  },
  statusPillMobileWarning: {
    backgroundColor: ticketColors.warnBg,
  },
  statusPillMobileText: {
    fontSize: 10,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  statusPillMobileTextSuccess: {
    color: ticketColors.ok,
  },
  statusPillMobileTextWarning: {
    color: ticketColors.gold,
  },
  infoPanelMobile: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    padding: 14,
    gap: 10,
  },
  infoPanelMobileTitle: {
    fontSize: 14,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  infoPanelMobileSubtitle: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink2,
    marginTop: -6,
  },
  metricRowMobile: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  metricCardMobile: {
    ...ticketSurfaces.paperSheet,
    flex: 1,
    minWidth: 72,
    borderRadius: 10,
    paddingVertical: 10,
    paddingHorizontal: 12,
    gap: 2,
  },
  metricLabelMobile: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink2,
  },
  metricValueMobile: {
    fontSize: 16,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  paymentLineMobile: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },
  paymentMethodMobile: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink2,
  },
  paymentAmountMobile: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  dividerMobile: {
    height: 1,
    backgroundColor: ticketColors.rule,
    marginVertical: 4,
  },
  fieldMobile: {
    gap: 4,
  },
  fieldLabelMobile: {
    fontSize: 13,
    fontWeight: '600',
    color: ticketColors.ink2,
  },
  helperTextMobile: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 16,
  },
  recordMobileActions: {
    flexDirection: 'column',
    gap: spacing.sm,
    alignSelf: 'stretch',
  },
  btnMobilePrimary: {
    alignSelf: 'stretch',
    minHeight: 44,
    borderRadius: 10,
    backgroundColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
    paddingHorizontal: 16,
  },
  btnMobilePrimaryText: {
    fontSize: 15,
    fontWeight: '800',
    color: ticketColors.goldInk,
  },
  btnMobileSecondary: {
    alignSelf: 'stretch',
    minHeight: 44,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    paddingVertical: 10,
    paddingHorizontal: 16,
  },
  btnMobileSecondaryText: {
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  kpiMobileGrid: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  kpiMobileCell: {
    width: '50%',
    backgroundColor: ticketColors.paper,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: ticketColors.ruleSoft,
    gap: 2,
  },
  kpiMobileCellThird: {
    borderRightWidth: 0,
  },
  kpiMobileCellLastRow: {
    borderBottomWidth: 0,
  },
  kpiMobileValue: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.3,
  },
  kpiMobileValueAccent: {
    color: ticketColors.gold,
  },
  kpiMobileLabel: {
    fontSize: 10,
    fontWeight: '600',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  linkMobileRow: {
    ...ticketSurfaces.paperSheet,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 14,
  },
  readOnlyMobileStrip: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.gold,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 10,
    backgroundColor: ticketColors.warnBg,
    borderWidth: 1,
    borderColor: ticketColors.warnBorder,
  },
  // ── Mobile bottom sheet ──
  sheetMobileContainer: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderTopWidth: 1,
    borderTopColor: ticketColors.rule,
    flexDirection: 'column',
    overflow: 'hidden',
    zIndex: 1,
  },
  sheetMobileGrabber: {
    width: 36,
    height: 4,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    marginTop: 8,
    marginBottom: 16,
    alignSelf: 'center',
  },
  sheetMobileHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.md,
    paddingBottom: spacing.sm,
    gap: spacing.sm,
  },
  sheetMobileTitle: {
    fontSize: 17,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  sheetMobileSubtitle: {
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.ink3,
    marginTop: 2,
  },
  sheetMobileClose: {
    width: 30,
    height: 30,
    borderRadius: 8,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sheetMobileCloseText: {
    fontSize: 16,
    color: ticketColors.ink3,
  },
  sheetMobileFooter: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    paddingBottom: 20,
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: spacing.sm,
  },
  historyRowMobile: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    paddingVertical: 12,
    paddingHorizontal: 14,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    marginBottom: 8,
  },
  historyLeftMobile: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  historyDateMobile: {
    fontSize: 14,
    fontWeight: '600',
    color: ticketColors.ink,
  },
  historyMetaMobile: {
    fontSize: 12,
    fontWeight: '500',
    color: ticketColors.ink3,
  },
  historyRightMobile: {
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 3,
  },
  historyAmountMobile: {
    fontSize: 16,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
  },
  historyDiffMobile: {
    fontSize: 12,
    fontWeight: '600',
  },
  pagerMobileRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
  },
  pagerMobileSummary: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink3,
  },
  pagerMobileButtons: {
    flexDirection: 'row',
    gap: 6,
  },
  pagerMobileBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  pagerMobileBtnActive: {
    backgroundColor: ticketColors.gold,
    borderColor: ticketColors.gold,
  },
  pagerMobileBtnDisabled: {
    opacity: 0.3,
  },
  pagerMobileBtnText: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  pagerMobileBtnTextActive: {
    color: ticketColors.goldInk,
    fontWeight: '700',
  },
  // ── Session detail bottom sheet (clean design) ──
  detailSheetContainer: {
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderTopWidth: 1,
    borderTopColor: ticketColors.rule,
    maxHeight: '92%',
    width: '100%',
    overflow: 'hidden',
    zIndex: 1,
  },
  detailSheetGrabber: {
    width: 36,
    height: 4,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    alignSelf: 'center',
    marginTop: 8,
    marginBottom: 16,
  },
  detailSheetHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.md,
    paddingBottom: spacing.sm,
    gap: spacing.sm,
  },
  detailSheetTitle: {
    fontSize: 17,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  detailSheetClose: {
    width: 30,
    height: 30,
    borderRadius: 8,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  detailSheetScroll: {
    flex: 1,
  },
  detailSheetContent: {
    paddingHorizontal: spacing.md,
    paddingBottom: spacing.md,
    gap: spacing.sm,
  },
  detailSheetFooter: {
    borderTopWidth: StyleSheet.hairlineWidth,
    borderTopColor: ticketColors.rule,
    paddingHorizontal: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: 20,
  },
  detailStatusRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
  },
  detailStatusLeft: {
    flex: 1,
    minWidth: 0,
    gap: 3,
  },
  detailStatusTitle: {
    fontSize: 17,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  detailStatusSubtitle: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink3,
    lineHeight: 17,
  },
  detailMetaBlock: {
    gap: 4,
  },
  detailMetaLine: {
    fontSize: 13,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 18,
  },
  detailKpiGrid: {
    flexDirection: 'row',
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
  },
  detailKpiCell: {
    flex: 1,
    backgroundColor: ticketColors.paper2,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRightWidth: 1,
    borderRightColor: ticketColors.ruleSoft,
    gap: 2,
  },
  detailKpiValue: {
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
    fontVariant: ['tabular-nums'],
    letterSpacing: -0.3,
  },
  detailKpiLabel: {
    fontSize: 10,
    fontWeight: '600',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  detailNoteBlock: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper2,
    paddingVertical: 12,
    paddingHorizontal: 14,
    gap: 4,
  },
  detailNoteLabel: {
    fontSize: 11,
    fontWeight: '700',
    color: ticketColors.ink3,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },
  detailNoteText: {
    fontSize: 14,
    fontWeight: '500',
    color: ticketColors.ink2,
    lineHeight: 20,
  },
  detailDivider: {
    height: 1,
    backgroundColor: ticketColors.rule,
    marginVertical: 4,
  },
});
